import { render, staticRenderFns } from "./resultWinning.vue?vue&type=template&id=ac011e40&scoped=true&"
import script from "./resultWinning.vue?vue&type=script&lang=js&"
export * from "./resultWinning.vue?vue&type=script&lang=js&"
import style0 from "./resultWinning.vue?vue&type=style&index=0&id=ac011e40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac011e40",
  null
  
)

export default component.exports